  export function updateFavIcon(iconName:any) {
    let link = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = `assets/favIcons/${iconName}.ico`;
    document.getElementsByTagName('head')[0].appendChild(link);
  }